import { useQuery } from '@tanstack/react-query';
import { DMAPathMap } from './dma-map-constants';
import { fetchDmaPaths } from './dma-map-utils';

const namesByCode = (paths: DMAPathMap): Record<string, string> =>
  Object.fromEntries(Object.entries(paths).map(([code, { name }]) => [code, name]));

// Each DMA's display name ("Miami-Fort Lauderdale, FL"), keyed by its Nielsen code ("528").
// Shares the DMA map's request, so a page with both fetches the file once.
export const useDmaNames = () =>
  useQuery({
    queryKey: ['dmaPaths'],
    queryFn: fetchDmaPaths,
    staleTime: Infinity,
    select: namesByCode
  });
